import $ from 'jquery'

export default {
	namespace: 'shop',
	beforeEnter() {

	},
	afterEnter() {


	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
